import { prismicClient } from "@jog/shared"

export const client = prismicClient({})
